module.exports = "/static/assets/8edfbf9184bf3dd8e3588a0f9fc13a3c.png";